import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/contact-us"
}, "Contact Us", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "spacer"
}, "|", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/support"
}, "Help", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    class: "footer-banner",
    type: "flex",
    justify: "space-between",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "left"
    }, {
      default: _withCtx(() => [_hoisted_1, _hoisted_2, _hoisted_3]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "center"
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
      _: 3
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "right"
    }, {
      default: _withCtx(() => [_createTextVNode(" © 2018-" + _toDisplayString(new Date().getFullYear().toString()) + " East View Geospatial ", 1)]),
      _: 1
    })]),
    _: 3
  });
}